// Shared orchestration across modules (addendum §10). Schemas in api-orchestration.ts.
import * as O from './api-orchestration.js';
import { IdParam, route, W } from './route-def.js';

export const orchestrationRoutes = {
  releaseContactLock: route({
    method: 'POST', path: '/workspaces/:workspaceId/contact-locks/:lockId/release',
    summary: 'Liberar a mano el bloqueo de un contacto por una llamada atascada (motivo obligatorio, auditado, idempotente)', tag: 'conversations',
    minRole: 'manager', module: null, params: W({ lockId: IdParam }), body: O.ReleaseContactLockSchema, response: O.ContactLockReleaseSchema,
  }),
};
